var $41c4b2bb61dafbca$exports = {};
$41c4b2bb61dafbca$exports = {
    "Empty": `Vac\xedo`
};


export {$41c4b2bb61dafbca$exports as default};
//# sourceMappingURL=es-ES.module.js.map
